import { useSyncHealth } from '../../hooks/useSyncHealth'
import {
  formatAge, SYNC_STATUS_BADGE, SYNC_STATUS_DOT, SYNC_STATUS_LABEL,
} from '../../lib/syncHealth'

/**
 * Saúde do sync (Obj 1 — consolidar estoque com precisão). Mostra o frescor de
 * cada fonte (saldo, vendas, notas, fornecedor) com semáforo e idade do último
 * registro. Alerta de "dados velhos" sem precisar abrir o ERP. Reusa o padrão
 * de card do restante das Configurações.
 */
export default function SyncHealthCard() {
  const { sources, overall, loading, error, refresh } = useSyncHealth()

  return (
    <section className="bg-surface border border-line rounded-xl p-4 sm:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <span className={`w-2.5 h-2.5 rounded-full ${SYNC_STATUS_DOT[overall]}`} />
          <h2 className="text-base font-semibold text-ink">Saúde do sync</h2>
          {!loading && (
            <span className={`text-[10px] font-semibold px-2 py-0.5 rounded ${SYNC_STATUS_BADGE[overall]}`}>
              {SYNC_STATUS_LABEL[overall]}
            </span>
          )}
        </div>
        <button
          onClick={refresh}
          disabled={loading}
          className="text-xs px-2.5 py-1 rounded-lg bg-sunken hover:bg-line text-ink-muted border border-line disabled:opacity-50"
        >
          {loading ? 'Verificando…' : '↻ Atualizar'}
        </button>
      </div>

      <p className="text-xs text-ink-faint mb-3">
        Frescor de cada fonte de dado. Saldo e vendas rodam por cron regular; notas e fornecedor
        são incrementais (gaps longos são normais).
      </p>

      {error ? (
        <p className="text-sm text-danger">{error}</p>
      ) : loading && sources.length === 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="h-[58px] rounded-lg border border-line bg-sunken/40 animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {sources.map(s => (
            <div key={s.key} className="rounded-lg border border-line bg-paper px-3 py-2.5 flex items-center justify-between gap-2">
              <div className="min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className={`w-2 h-2 rounded-full shrink-0 ${SYNC_STATUS_DOT[s.status]}`} />
                  <span className="text-sm font-medium text-ink truncate">{s.label}</span>
                </div>
                {s.hint && <p className="text-[11px] text-ink-faint mt-0.5 leading-snug truncate" title={s.hint}>{s.hint}</p>}
              </div>
              <div className="text-right shrink-0">
                <p className="text-sm font-semibold tabular-nums text-ink leading-tight">{formatAge(s.ageH)}</p>
                <p className={`text-[10px] font-semibold ${
                  s.status === 'fresh' ? 'text-emerald-600 dark:text-emerald-400'
                  : s.status === 'stale' ? 'text-amber-600 dark:text-amber-400'
                  : 'text-red-600 dark:text-red-400'
                }`}>{SYNC_STATUS_LABEL[s.status]}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}
